import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=dc1b1a54&"
import script from "./Default.vue?vue&type=script&lang=js&"
export * from "./Default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc1b1a54')) {
      api.createRecord('dc1b1a54', component.options)
    } else {
      api.reload('dc1b1a54', component.options)
    }
    module.hot.accept("./Default.vue?vue&type=template&id=dc1b1a54&", function () {
      api.rerender('dc1b1a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/Default.vue"
export default component.exports